import React from "react";
import {
  GridColumn,
  Header,
  Segment,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "semantic-ui-react";
import moment from "moment";

const SwapStateHistoryTable = ({ swapStateHistory }) => {
  return (
    <GridColumn>
      <Segment>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Header style={{ color: "#444" }}>
            {swapStateHistory.length} State History
          </Header>
        </div>
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell className="left-header">
                state id
              </Table.HeaderCell>

              <Table.HeaderCell className="inner-header">
                State
              </Table.HeaderCell>
              <Table.HeaderCell className="inner-header">
                Title
              </Table.HeaderCell>
              <Table.HeaderCell className="inner-header">Body</Table.HeaderCell>

              <Table.HeaderCell className="right-header">
                Timestamp
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <TableBody>
            {swapStateHistory.map(
              ({
                swap_state,
                swap_id,
                swap_state_id,
                timestamp,
                error_title,
                error_body,
              }) => (
                <TableRow>
                  <TableCell>{swap_state_id}</TableCell>
                  <TableCell>{swap_state?.toUpperCase()}</TableCell>
                  <TableCell>{error_title}</TableCell>

                  <TableCell>{error_body}</TableCell>

                  <TableCell>
                    {moment(timestamp).format("DD-MM-YYYY HH:mm:ss")}
                  </TableCell>
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
        {!swapStateHistory.length && (
          <div style={{ alignSelf: "center", color: "#444", width: "100%" }}>
            no data available
          </div>
        )}
      </Segment>
    </GridColumn>
  );
};

export default SwapStateHistoryTable;
